<header class="header" role="banner">
  <div class="header-left">

    <!-- Logo and Title -->
    <div class="brand">
      <div class="brand-icon-wrapper">
        <svg class="brand-icon" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <!-- Tooth Icon -->
          <path 
            d="M16 3C12.5 3 10 4.5 8.5 7C7 9.5 6.5 12 6.5 14.5C6.5 17 7 19.5 8 22C9 24.5 10.5 27 11.5 28.5C12 29 12.5 29 13 28.5C13.5 28 14 26 14.5 23.5C14.75 22 15.25 21 16 21C16.75 21 17.25 22 17.5 23.5C18 26 18.5 28 19 28.5C19.5 29 20 29 20.5 28.5C21.5 27 23 24.5 24 22C25 19.5 25.5 17 25.5 14.5C25.5 12 25 9.5 23.5 7C22 4.5 19.5 3 16 3Z"
            fill="white"
            stroke="var(--primary)"
            stroke-width="2"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <span class="brand-text">{{ 'HEADER.BRAND_TITLE' | translate }}</span>
    </div>

    <button class="menu-toggle" type="button" (click)="onToggleMenu()"
      [attr.aria-label]="'COMMON.TOGGLE_MENU' | translate" [attr.aria-expanded]="true">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 12H21M3 6H21M3 18H21" stroke="currentColor" stroke-width="2" stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    </button>

    @if (branchOptions().length > 0) {
      <div class="branch-selector">
        <lib-dropdown
          class="header-branch-dropdown"
          [(ngModel)]="selectedBranchId"
          [options]="branchOptions()"
          [isLoading]="isLoadingBranches()"
          [showSelectOption]="false"
          [placeholder]="'HEADER.SELECT_BRANCH' | translate"
          (selectionChange)="onBranchChange($event)">
        </lib-dropdown>
      </div>
    }

    <!-- Header Content Projection -->
    <ng-content select="[header-content]"></ng-content>
  </div>

  <div class="header-right">
    <!-- User Menu -->
    <div class="user-menu">

      <div class="user-button">
        <button class="user-avatar" 
          type="button"
          (click)="onAvatarClick($event)"
          [attr.aria-label]="'CHANGE_AVATAR' | translate">
          @if (userAvatarUrl()) {
          <img [src]="userAvatarUrl()" alt="User Avatar" class="user-avatar-img" />
          } @else if (userInitials) {
          <span class="user-initials">{{ userInitials }}</span>
          } @else {
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M10 10C12.7614 10 15 7.76142 15 5C15 2.23858 12.7614 0 10 0C7.23858 0 5 2.23858 5 5C5 7.76142 7.23858 10 10 10Z"
              fill="currentColor" />
            <path d="M10 12C5.58172 12 2 15.5817 2 20H18C18 15.5817 14.4183 12 10 12Z" fill="currentColor" />
          </svg>
          }
        </button>
        <div class="user-info"
          role="button"
          tabindex="0"
          (click)="toggleDropdown()"
          (keydown.enter)="toggleDropdown()"
          (keydown.space)="$event.preventDefault(); toggleDropdown()"
          [attr.aria-label]="'COMMON.USER_MENU' | translate" 
          [attr.aria-expanded]="isDropdownOpen">
          @if (userFullName) {
          <span class="user-name">{{ userFullName }}</span>
          }
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
            [class.rotated]="isDropdownOpen">
            <path d="M4 6L8 10L12 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </div>
      </div>

      @if (isDropdownOpen) {
      <div class="user-dropdown">
        @if (isAuthorizedForAccount()) {
        <button class="dropdown-item" type="button" (click)="navigateToProfile()">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M8 8C9.65685 8 11 6.65685 11 5C11 3.34315 9.65685 2 8 2C6.34315 2 5 3.34315 5 5C5 6.65685 6.34315 8 8 8Z"
              stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path
              d="M2.66667 14C2.66667 11.4227 4.75601 9.33333 7.33333 9.33333H8.66667C11.244 9.33333 13.3333 11.4227 13.3333 14"
              stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <span>{{ 'COMMON.ACCOUNT' | translate }}</span>
        </button>
        }
        <button class="dropdown-item logout" type="button" (click)="logout()">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M6 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H6"
              stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M10.6667 11.3333L14 8L10.6667 4.66667" stroke="currentColor" stroke-width="1.5"
              stroke-linecap="round" stroke-linejoin="round" />
            <path d="M14 8H6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <span>{{ 'COMMON.LOGOUT' | translate }}</span>
        </button>
      </div>
      }
    </div>
  </div>
</header>

@if (showAvatarDialog()) {
<lib-profile-avatar-dialog (closeDialog)="onAvatarDialogClose()" (saved)="onAvatarDialogClose()"></lib-profile-avatar-dialog>
}